import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './alert.svg'
import _imports_1 from './spolar.svg'


_pushScopeId("data-v-cf8b8854")
const _hoisted_1 = { class: "sunrise-title py-10" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = { class: "sunrise-title-text uppercase" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sunrise-subtitle-text" }, "Sunrise", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-[12px]"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_1
}, null, -1)
const _hoisted_7 = { class: "num-tokens" }
const _hoisted_8 = { class: "details" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "details" }, "SPOLAR Staked", -1)
const _hoisted_10 = {
  key: 0,
  class: "mt-[24px] flex justify-center gap-[12px]"
}
const _hoisted_11 = { class: "absolute mt-[80px]" }
const _hoisted_12 = {
  key: 1,
  class: "container mt-[24px] flex justify-center gap-[12px]"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "absolute mt-[80px]" }
const _hoisted_15 = { class: "data-text text-right" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "Next Epoch:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Current Epoch:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, "Previous Epoch (TWAP):", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "TWAP to print:", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "APR:", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "SPOLARS Staked", -1)
const _hoisted_22 = { class: "data-text" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "num-tokens" }
const _hoisted_25 = { class: "details" }
const _hoisted_26 = { class: "details" }
const _hoisted_27 = { class: "uppercase" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Earned ")
const _hoisted_29 = { class: "mt-[24px] flex justify-center gap-[12px]" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", { class: "single-stake-btn" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "single-stake-btn-text" }, "Single Stake")
], -1)
const _hoisted_32 = { class: "absolute mt-[80px]" }
const _hoisted_33 = { class: "w-full" }
const _hoisted_34 = ["disabled"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpolarModal = _resolveComponent("SpolarModal")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.sunrise.name), 1),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex justify-center", { sunriseWarning: _ctx.isDesktop, sunriseWarningMobile: _ctx.isMobile }])
    }, [
      _hoisted_5,
      _createElementVNode("div", null, " As we are in recovery mode, it is important to not sell your reward. Please stake your " + _toDisplayString(_ctx.sunrise.name.toUpperCase()) + " in the EARN single stake. ", 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({ info: _ctx.isDesktop, infoMobile: _ctx.isMobile })
    }, " Staked SPOLARs can only be withdrawn after 3 epochs since deposit. ", 2),
    _createElementVNode("div", {
      class: _normalizeClass([{ sunrise: _ctx.isDesktop, sunriseMobile: _ctx.isMobile }, "justify-center text-center"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ card: _ctx.isDesktop, cardMobile: _ctx.isMobile })
      }, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.depositedBalance), 1),
        _createElementVNode("div", _hoisted_8, "$" + _toDisplayString(_ctx.depositedInDollars), 1),
        _hoisted_9,
        (!_ctx.approved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "claim-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
              }, "Approve Spolar"),
              _createElementVNode("div", _hoisted_11, " Withdraw possible in: " + _toDisplayString(_ctx.withdrawTime), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "claim-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSpolarModal(true)))
              }, " Deposit "),
              _createVNode(_component_SpolarModal, {
                depositBol: true,
                isVisible: _ctx.isSpolarModalVisible,
                deposit: _ctx.depositToken,
                balance: _ctx.balance,
                onClose: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.toggleSpolarModal();
            _ctx.fetchData();
          })
              }, null, 8, ["isVisible", "deposit", "balance"]),
              _createVNode(_component_SpolarModal, {
                isVisible: _ctx.isSpolarWithdrawModalVisible,
                deposit: _ctx.depositToken,
                balance: _ctx.depositedBalance,
                onClose: _ctx.toggleSpolarWithdrawModal
              }, null, 8, ["isVisible", "deposit", "balance", "onClose"]),
              _createElementVNode("button", {
                class: "withdraw-btn",
                disabled: !_ctx.canWithdraw || !(parseFloat(_ctx.depositedBalance) > 0),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSpolarWithdrawModal(false)))
              }, " Withdraw ", 8, _hoisted_13),
              _createElementVNode("div", _hoisted_14, " Withdraw possible in: " + _toDisplayString(_ctx.withdrawTime), 1)
            ]))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ data: _ctx.isDesktop, dataMobile: _ctx.isMobile })
      }, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", null, _toDisplayString(_ctx.sunrise.name.toUpperCase()) + " Price (TWAP):", 1),
          _hoisted_18,
          _hoisted_19,
          _hoisted_20,
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", null, _toDisplayString(_ctx.nextEpoch), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.epoch), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.twap), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.lastEpochTwap), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.printTwap), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.APR) + "%", 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.spolarsStaked), 1)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ card: _ctx.isDesktop, cardMobile: _ctx.isMobile })
      }, [
        _createElementVNode("img", {
          class: "logo",
          src: _ctx.logo[_ctx.sunrise.name]
        }, null, 8, _hoisted_23),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.earned), 1),
        _createElementVNode("div", _hoisted_25, "$" + _toDisplayString(_ctx.earnedAmountInDollars), 1),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.sunrise.name), 1),
          _hoisted_28
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", {
            class: "claim-btn",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.claim && _ctx.claim(...args))),
            disabled: !(parseFloat(_ctx.earned) > 0) || !_ctx.canClaim
          }, " Claim ", 8, _hoisted_30),
          _createVNode(_component_router_link, {
            to: '/singlestake/' + _ctx.sunrise['name']
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_32, "Claim possible in: " + _toDisplayString(_ctx.claimTime), 1)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("button", {
          class: "claim-btn",
          "text-center": "",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.withdrawAll && _ctx.withdrawAll(...args))),
          disabled: !_ctx.canWithdraw || !(parseFloat(_ctx.depositedBalance) > 0)
        }, " Claim and withdraw ", 8, _hoisted_34)
      ])
    ], 2)
  ], 64))
}